import React from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { DnpLink } from '../../../models/DnpLink';
import ServicesContext from '../../../contexts/ServicesContext';
import { IWidthColumnDnpLinksTable } from './useDnpLinksTable';
import { CopyButton, OptionsLink } from './styles';

interface IDnpLinksTableRowProps {
    dnpLink: DnpLink;
    widthColumn: IWidthColumnDnpLinksTable;
}

const DnpLinksTableRow: React.FC<IDnpLinksTableRowProps> = ({
    dnpLink,
    widthColumn
}) => {

    const {
        toastService
    } = React.useContext(ServicesContext);

    const externalLink = `https://zerezes.com.br/pages/minha-dnp?token=${dnpLink.token}`;

    return (
        <tr key={`order-${dnpLink.id}`}>
            <td style={{width:widthColumn.RequesterName}}>
                {dnpLink.requesterName}
            </td>
            <td style={{width:widthColumn.CreatedAt, minWidth:widthColumn.CreatedAt, maxWidth:widthColumn.CreatedAt}}>
                {moment(dnpLink.createdAt).format('DD/MM/yyyy HH:mm:ss')}
            </td>
            <td style={{width:widthColumn.ExpirationDate, minWidth:widthColumn.ExpirationDate, maxWidth:widthColumn.ExpirationDate}}>
                {moment(dnpLink.expirationDate).format('DD/MM/yyyy HH:mm')}
            </td>
            <td style={{width:widthColumn.Link, minWidth:widthColumn.Link, maxWidth:widthColumn.Link}}>
                <OptionsLink>
                    <CopyButton title='Copiar' onClick={() => copyExternalLinkToClipboard()}><FontAwesomeIcon icon={faCopy} color='#0d6efd' size='1x' /></CopyButton>
                </OptionsLink>
            </td>
        </tr>
    );

    function copyExternalLinkToClipboard() {
        try {
            navigator.clipboard.writeText(externalLink);
            toastService.success('Link copiado com sucesso. Agora você pode usar o Ctrl+V para colar em outro lugar!');
        } catch {
            toastService.error('Não foi possível copiar o link. Tente novamente!');
        }
    }
}

export {DnpLinksTableRow};